var activeElement;
export default {
  get element() {
    return activeElement;
  },
  set: function set(element) {
    activeElement = element;
  }
};